import Vue from 'vue'
import VuetableFieldCheckbox from "@/plugins/vuetable-checkbox/VuetableFieldCheckboxLoad";
// import VuetableFieldCheckbox from '@/plugins/vuetable-checkbox/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import store from '@/store/main.js';

Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)
import i18n from '@/plugins/i18n';

function formatNumberDigit(value) {
    return numeral(value).format("0,0");
}

export default [
    {
        name: VuetableFieldCheckbox,
        id: 'checkbox',
        title: "checkbox",
        visible: true,
        width: "10px",
        disabled: function (rowData) {
            return false;
        },
    },
    {
        id: 'image',
        name: 'image',
        title: i18n.t('Ch.'),
        width: "25px",
        visible: true,
        togglable: true
    },
    {
        id: 'channel_name',
        name: 'name',
        title: i18n.t('Channel Name'),
        visible: true,
        width: "100px",
        togglable: true
    },
    {
        id: 'group',
        name: 'group',
        title: i18n.t('Integration Type'),
        width: "50px",
        visible: true,
        togglable: true
    },
    {
        id: 'status',
        name: 'status',
        width: "25px",
        title: i18n.t('Status'),
        togglable: true
    },
    {
        id: 'number_of_orders',
        name: 'sum_sale_order',
        width: "60px",
        title: i18n.t('Number of Orders'),
        visible: true,
        togglable: false,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    }
];



// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/assets/pageListFields.js